import PropTypes from 'prop-types'
import { Card } from '@components/ui/card'
import { cn } from 'lib/utils'

export const AdasCard = ({ children, className, elevation, sx, ...props }) => (
  <Card
    className={cn(
      'rounded-card',
      elevation === 1 && 'shadow-sm border border-border',
      elevation === 2 && 'shadow-md border-0',
      elevation === 3 && 'shadow-lg border-0',
      !elevation && 'shadow-sm border border-border',
      className
    )}
    {...props}
  >
    {children}
  </Card>
)

AdasCard.propTypes = { children: PropTypes.node, className: PropTypes.string, elevation: PropTypes.number }
